import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'pbh9u5o8',
  dataset: 'new_database',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skq0Y43L9xcFotI8hgsSFAD3IxMNtG4REDP166DvoSbCcWBOpptD0K99avP6pZ3fiNuCW0t0ozv81SxH90pwNvQhYTzpLcTE2NfELlZbSIZ2FZmENo3K5Mu9sm7O7xuvlvqmfcSmjIyrVgAryBzAbcrJsuoHf64gMdpAC14eW7dPcnq8p9ZL',
});
const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);


//  token: 'skhS4TSWYNHgbhYsp7FztiaVxrSvDmhiI5itye9MkDwPJ3M4njwR1KZWUUjV7MqVt2U2fHdl8OtQjc5zyK2utCC2VlSk7ihsO7Mo1ALWejOZug8mADnT66mS7DSbJVLYQ80sNCqMTBBjdEwRVfrTZtceC8RVjMErS7yVb1Ix5GYBciKGhlqJ',
